import { type ComponentPropsWithoutRef, useEffect, useState } from 'react';
import type { AvatarData } from '@/api/gen/_model/avatarData';
import { type PlanType } from '@/types';
import { cn } from '@/utils/tailwind.util';
import { AVATAR_BG_COLOR, type AvatarShape, type AvatarSize, buildBakedAvatarUrl, PLAN_GRADIENT_CLASS, SHAPE_MAP, SIZE_MAP } from '../constants/avatar.constants';
import { AvatarFrame } from './AvatarFrame';
import { FallbackAvatar } from './FallbackAvatar';
export const BakedAvatar = ({
  avatarData,
  size = 'xs',
  shape = 'circle',
  planType,
  backgroundColor,
  className,
  style,
  ...props
}: ComponentPropsWithoutRef<'div'> & {
  avatarData: AvatarData;
  size?: AvatarSize;
  shape?: AvatarShape;
  planType?: PlanType;
  backgroundColor?: string;
}) => {
  const [hasError, setHasError] = useState(false);
  const imageUrl = buildBakedAvatarUrl(avatarData);
  useEffect(() => {
    setHasError(false);
  }, [imageUrl]);
  if (hasError) {
    return <FallbackAvatar size={size} shape={shape} planType={planType} className={className} style={style} {...props} />;
  }
  const bakedImage = <img src={imageUrl} alt="avatar" className="size-full object-cover" onError={() => !hasError && setHasError(true)} />;
  const gradientClass = PLAN_GRADIENT_CLASS[planType ?? 'FREE'];
  if (!gradientClass) {
    return <AvatarFrame shape={shape} backgroundColor={backgroundColor ?? AVATAR_BG_COLOR} className={cn(SIZE_MAP[size], className)} style={style} {...props}>
        {bakedImage}
      </AvatarFrame>;
  }

  // 플랜 그라데이션 링은 프레임 바깥을 감싸는 별개 레이어다. 링이 곧 테두리 역할을
  // 하므로 안쪽은 AvatarFrame(=보더 있는 프레임)이 아니라 클리핑 컨테이너만 둔다.
  return <div className={cn('relative inline-flex aspect-square shrink-0 p-[2px]', SHAPE_MAP[shape], gradientClass, SIZE_MAP[size], className)} style={style} {...props} data-sentry-component="BakedAvatar" data-sentry-source-file="BakedAvatar.tsx">
      <div className={cn('flex aspect-square size-full overflow-hidden', SHAPE_MAP[shape])} style={{
      backgroundColor: backgroundColor ?? AVATAR_BG_COLOR
    }}>
        {bakedImage}
      </div>
    </div>;
};